// 🪟 Document Picture-in-Picture — 같은 JS 컨텍스트를 유지한 채 DOM 일부를 별도 창으로 띄운다.
//
// 왜 이 API 인가 (2026-08-18): 1:1 통화 중 상대 화면은 그 창의 RTCPeerConnection 이 만든 MediaStream 이라
//   다른 창(window.open·Tauri WebviewWindow)으로는 옮길 수 없다 — 창이 다르면 세션을 새로 맺어야 하는데
//   통화는 세션이 하나뿐이다. Document PiP 는 같은 문서 컨텍스트의 별도 창이라 스트림이 그대로 산다.
//   (방 화면공유는 시청 세션을 새로 맺을 수 있어 /share 팝아웃 창을 쓴다 — 그쪽이 더 견고.)
//
// 미지원 환경(구 WebView2·모바일 웹뷰)에서는 null 을 돌려주고, 호출부는 기존 오버레이를 유지한다.
interface DocumentPipApi {
	requestWindow: (opts?: { width?: number; height?: number }) => Promise<Window>;
	window?: Window | null;
}

function api(): DocumentPipApi | null {
	if (typeof window === 'undefined') return null;
	const a = (window as unknown as { documentPictureInPicture?: DocumentPipApi }).documentPictureInPicture;
	return a && typeof a.requestWindow === 'function' ? a : null;
}

export function pipSupported(): boolean {
	return api() !== null;
}

/**
 * PiP 창을 열고 최소 스타일(여백 0·검은 배경·꽉 채운 비디오)을 심어 돌려준다.
 * 부모 스타일시트는 상속되지 않으므로 필요한 규칙만 직접 넣는다(Tailwind 전체 복사는 과함).
 */
export async function openPipWindow(width = 960, height = 600): Promise<Window | null> {
	const a = api();
	if (!a) return null;
	try {
		const w = await a.requestWindow({ width, height });
		const st = w.document.createElement('style');
		st.textContent = [
			'*{box-sizing:border-box}',
			'html,body{margin:0;height:100%;background:#000;color:#fff;font-family:system-ui,"Segoe UI",sans-serif}',
			'.pip-root{display:flex;flex-direction:column;height:100%}',
			'.pip-bar{display:flex;align-items:center;gap:8px;padding:6px 10px;font-size:12px;background:rgba(255,255,255,.08)}',
			'.pip-video{flex:1;min-height:0;width:100%;object-fit:contain;background:#000}',
		].join('');
		w.document.head.appendChild(st);
		return w;
	} catch { return null; }   // 사용자 제스처 없음·정책 거부 등
}
